<template>
  <el-container style="height: 100%; background-color: #070809">
    <el-aside width="260px" style="height:100%;">
      <div class="img-div">
        <img src="./assets/logo.png" />
      </div>
      <el-menu
        text-color="#eee"
        active-text-color="#fff"
        background-color="#070809"
        style="overflow:auto;height:calc(100% - 130px);padding:10px;margin:0;"
        router
        :default-active="$route.path"
      >
        <el-divider style="color: white" content-position="center"
          >设备</el-divider
        >
        <el-menu-item index="/deviceList" @click="active = 1">
          <img v-if="active == 1" src="./assets/img/基本信息-已选择.png" />
          <img v-else src="./assets/img/基本信息-未选择.png" />
          <span style="padding-left: 5px">设备列表</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>
        <el-menu-item index="/allUserDeviceList" @click="active = 2">
          <img v-if="active == 2" src="./assets/img/测试题目-已选择(3).png" />
          <img v-else src="./assets/img/测试题目-未选择(3).png" />
          <span style="padding-left: 5px">所有用户设备</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>

        <el-divider style="color: white" content-position="center"
          >曲线</el-divider
        >
        <el-menu-item index="/curveList" @click="active = 3">
          <img v-if="active == 3" src="./assets/img/测试题目-已选择.png" />
          <img v-else src="./assets/img/测试题目-未选择.png" />
          <span style="padding-left: 5px">曲线列表</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>
        <!-- <el-menu-item index="/curveRecommend" @click="active = 4">
          <img v-if="active == 4" src="./assets/img/测试题目-已选择(4).png" />
          <img v-else src="./assets/img/测试题目-未选择(4).png" />
          <span style="padding-left: 5px">推荐曲线</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>
        <el-menu-item index="/curveCollect" @click="active = 5">
          <img v-if="active == 5" src="./assets/img/测试题目-已选择(5).png" />
          <img v-else src="./assets/img/测试题目-未选择(5).png" />
          <span style="padding-left: 5px">收藏曲线</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>
        <el-menu-item index="/allUserCurveList" @click="active = 6">
          <img v-if="active == 6" src="./assets/img/测试题目-已选择(7).png" />
          <img v-else src="./assets/img/测试题目-未选择(7).png" />
          <span style="padding-left: 5px">所有用户曲线</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item> -->

        <el-divider style="color: white" content-position="center"
          >杯测</el-divider
        >
        <el-menu-item index="/cupList" @click="active = 7">
          <img v-if="active == 7" src="./assets/img/测试题目-已选择(1).png" />
          <img v-else src="./assets/img/测试题目-未选择(1).png" />
          <span style="padding-left: 5px">杯测列表</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>
        <el-menu-item index="/allUserCupList" @click="active = 8">
          <img v-if="active == 8" src="./assets/img/测试题目-已选择(8).png" />
          <img v-else src="./assets/img/测试题目-未选择(8).png" />
          <span style="padding-left: 5px">所有用户杯测</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>

        <el-divider style="color: white" content-position="center"
          >仓储</el-divider
        >
        <el-menu-item index="/storageStatus" @click="active = 9">
          <img v-if="active == 9" src="./assets/img/测试题目-未选择(2).png" />
          <img v-else src="./assets/img/测试题目-未选择(2).png" />
          <span style="padding-left: 5px">仓储状态</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>
        <el-menu-item index="/allUserStorage" @click="active = 10">
          <img v-if="active == 10" src="./assets/img/测试题目-已选择(9).png" />
          <img v-else src="./assets/img/测试题目-未选择(9).png" />
          <span style="padding-left: 5px">所有用户仓储</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>

        <el-divider style="color: white" content-position="center"
          >设置</el-divider
        >
        <el-menu-item index="/systemSetting" @click="active = 11">
          <img v-if="active == 11" src="./assets/img/测试题目-已选择(6).png" />
          <img v-else src="./assets/img/测试题目-未选择(6).png" />
          <span style="padding-left: 5px">系统设置</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>
        <el-menu-item index="/accountManagement" @click="active = 12">
          <img v-if="active == 12" src="./assets/img/测试题目-已选择(10).png" />
          <img v-else src="./assets/img/测试题目-未选择(10).png" />
          <span style="padding-left: 5px">账户管理</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>
        <el-menu-item index="/userManagement" @click="active = 13">
          <img v-if="active == 13" src="./assets/img/测试题目-已选择(11).png" />
          <img v-else src="./assets/img/测试题目-未选择(11).png" />
          <span style="padding-left: 5px">用户管理</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header style="text-align: right; font-size: 12px;">
        <el-row>
          <el-col :span="12"></el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <el-breadcrumb
          separator="/"
          separator-class="el-icon-arrow-right"
          style="height: 30px;width:200px;margin-top: 24px; font-size: 15px"
        >
          <el-breadcrumb-item>当前位置</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: menuList[active].path }">{{
            menuList[active].name
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-header>

      <el-main style="flex-basis:800px;">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  created: function() {
    this.$router.push("/deviceList");
  },
  data() {
    return {
      active: 1,
      menuList: [
        "",
        {
          path: "/deviceList",
          name: "设备列表",
        },
        {
          path: "/allUserDeviceList",
          name: "所有用户设备",
        },
        {
          path: "/curveList",
          name: "曲线列表",
        },
        {
          path: "/curveRecommend",
          name: "推荐曲线",
        },
        {
          path: "/curveCollect",
          name: "收藏曲线",
        },
        {
          path: "/allUserCurveList",
          name: "所有用户曲线",
        },
        {
          path: "/cupList",
          name: "杯测列表",
        },
        {
          path: "/allUserCupList",
          name: "所有用户杯测",
        },
        {
          path: "/storageStatus",
          name: "仓储状态",
        },
        {
          path: "/allUserStorage",
          name: "所有用户仓储",
        },
        {
          path: "/systemSetting",
          name: "系统设置",
        },
        {
          path: "/accountManagement",
          name: "账户管理",
        },
        {
          path: "/userManagement",
          name: "用户管理",
        },
      ],
    };
  },
  methods: {
    menuRouter: function(index, indexPath) {
      console.info(index);
      console.info(indexPath);
      this.$router.push(index);
    },
  },
};
</script>

<style scoped>
.el-main {
  padding: 0px;
}

.img-div {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.el-menu-item {
  height: 40px;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.el-divider {
  margin-top: 15px;
  margin-bottom: 15px;
}

.el-divider /deep/ .el-divider__text {
  color: white;
  background-color: #070809;
}

.el-divider el-divider--horizontal {
  color: #dddddd;
}

.el-menu {
  margin: 20px;
  border-right: 0 !important;
}
</style>
